import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left-arrow",
  "use": "left-arrow-usage",
  "viewBox": "0 0 140 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 140 90\" id=\"left-arrow\">\n  <path fill-rule=\"evenodd\" d=\"M36.616 68.884a1.25 1.25 0 0 0 1.768-1.768L15.518 44.25H127.5a1.25 1.25 0 0 0 0-2.5H15.518l22.866-22.866a1.25 1.25 0 0 0-1.768-1.768L11.62 42.112a1.246 1.246 0 0 0-.004 1.772l25 25Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol